export const LOAD_COUNTRIES_REQUESTED = 'LOAD_COUNTRIES_REQUESTED';
export const LOAD_COUNTRIES_SUCCEEDED = 'LOAD_COUNTRIES_SUCCEEDED';
export const LOAD_COUNTRIES_FAILED = 'LOAD_COUNTRIES_FAILED';
